import styled from 'styled-components'

export const SocialListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 575px) {
    justify-content: center;
  }
`
